"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getter_1 = require("./getter");
var decorator_1 = require("./decorator");
function numberOr(root, path, decorators, orElse) {
    if (path === void 0) { path = ''; }
    if (decorators === void 0) { decorators = []; }
    if (orElse === void 0) { orElse = 0; }
    /*
     * Slight gotchas:
     * 1) Invoking a new number with the 'new Number' constructor causes
     *    TS issues.
     * 2) If the condtitional statement is used in the constructor a
     *    field with a non-numeric value will appear truthy resulting in
     *    a NaN numeric type.
     */
    return (Number(decorator_1.decorate(getter_1.getDefinedOrElse(root, path, orElse), decorators)) || 0);
}
exports.numberOr = numberOr;
//# sourceMappingURL=numberOr.js.map